enum AccessChangeOption {
  KEEP_PAGE = "keepPage",
  RELOAD = "reload",
  UPDATE_PAGE = "updatePage",
}

export default AccessChangeOption;
